import { render } from "./UserConf.vue?vue&type=template&id=d198b2aa&lang=true"
import script from "./UserConf.vue?vue&type=script&lang=js"
export * from "./UserConf.vue?vue&type=script&lang=js"

import "./UserConf.vue?vue&type=style&index=0&id=d198b2aa&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__